import { Dispatch } from '@reduxjs/toolkit'

import { esApi } from '@/app/store/api'

export const invalidatePhoneNumbersCache = async (dispatch: Dispatch) => {
  dispatch(esApi.util.invalidateTags(['OrgDid']))
}
